<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
        <div class="card">
            <FlashMessage :position="'right top'"></FlashMessage>

            <div class="card-header">
                <h4 class="title">Add Category</h4>
            </div>
            <div class="card-body">
                <form @submit.prevent="submit" enctype="multipart/form-data">
                    <div class="row">
                        <div class="col-md-4">
                            <label>Category<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.categorydata.categoryname.$model" type="text" label="Category" placeholder="Enter category" />
                            <div class="error" v-if="submitted && !$v.categorydata.categoryname.required">Please enter category</div>

                        </div>

                        <div class="col-md-4">
                            <label>Image<em style="color:red">*</em></label>
                            <input class="form-control" type="file" label="Image" name="categoryimage" id="categoryimage" @change="onFileSelected" accept="image/x-png,image/gif,image/jpeg" />
                            <div class="error" v-if="submitted && !$v.categorydata.categoryimage.required">Please select image</div>

                        </div>

                        <div class="col-md-4">
                            <label>Status<em style="color:red">*</em></label>
                            <select class="form-control" v-model.trim="$v.categorydata.categorystatus.$model">
                                <option disabled>Select status</option>
                                <option value="1">Active</option>
                                <option value="0">InActive</option>
                            </select>
                            <div class="error" v-if="submitted && !$v.categorydata.categorystatus.required">Please select status</div>

                        </div>

                    </div>

                    <div class="text">
                        <button type="submit" class="btn btn-secondary dashboard">Add Category</button>&nbsp;
                        <router-link to="/admin/dashboard/category"><button type="button" class="btn btn-secondary dashboard">Cancel</button></router-link>

                    </div>

                </form>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import ValidationError from "src/components/UIComponents/ValidationError.vue";
import {
    required,
    minLength,
    maxLength,
    between,
    file_size_validation,
} from "vuelidate/lib/validators";
import {
    exit
} from "process";
export default {
    name: 'addCategory',
    components: {
        TopNavbar,
        ContentFooter,
        ValidationError,

    },

    data() {
        return {
            submitted: false,

            categorydata: {
                categoryname: '',
                categoryimage: [],
                categorystatus: 1,
            }
        }
    },

    validations: {
        categorydata: {
            categoryname: {
                required,
            },
            categoryimage: {
                required,
            },
            categorystatus: {
                required,
            },
        }
    },

    methods: {

        onFileSelected(event) {
            this.categorydata.categoryimage = event.target.files[0];
        },

        submit() {

            let formData = new FormData();
            formData.append('categoryimage', this.categorydata.categoryimage);
            formData.append('categoryname', this.categorydata.categoryname);
            formData.append('categorystatus', this.categorydata.categorystatus);
    
            this.submitted = true;
            this.$v.$touch()

            if (this.$v.$invalid) {
                return;
            } else {
                this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/addcategory`, formData)
                    .then(({
                        data
                    }) => {
                        this.$router.push('/admin/dashboard/category');
                        this.flashMessage.success({
                            message: 'Category Added Successfully',
                        });
                    })
                // .catch((error) => {
                //     console.log(error);
                // });

            }
        }
    },

};
</script>

<style lang="scss">
</style>
